export default __webpack_public_path__ + "static/media/Campus-hr-v-g.57c06027.svg";